<template>
    <div class="page" id="playerBook">
        <header class="pageHeader rounded">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Edit Booking</h2>
                <ul class="links">
                    <li>
                        <a class="cancel" @click.prevent="$router.back()" href="#">
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <form class="form3" @submit.prevent="updateBooking">
                <div class="select" v-if="user.type == 'pro'">
                    <select
                        class="button dark"
                        v-model="form.player_id"
                        :class="{ complete: form.player_id }"
                    >
                        <option value="">Add Player</option>
                        <option value="guest">Guest</option>
                        <option v-for="player in players" :key="player.id" :value="player.id">
                            {{ player.first_name }}
                            {{ player.last_name }}
                        </option>
                    </select>
                    <img class="arrow" src="~@/assets/arrow-right-white-2.svg" />
                </div>

                <has-error class="info error" :form="form" field="player_id" />

                <div class="formGroup" id="guestName" v-if="form.player_id == 'guest'">
                    <input
                        v-model="form.guest_name"
                        type="text"
                        placeholder="Guest name..."
                        :class="{ complete: form.guest_name }"
                    />
                </div>
                <has-error class="info error" :form="form" field="guest_name" />

                <!-- <div class="select"> 
          <select class="button dark" v-model="form.duration" @change="resetForm" :class="{'complete':form.duration}">
            <option value="">Select duration</option>
            <option value="15">15 minutes {{(user && user.lesson_settings && user.lesson_settings.preffered_lesson_duration == "15" || (!user.lesson_settings)) ? '(Preferred duration)' : ''}}</option>
            <option value="30">30 minutes {{(user && user.lesson_settings && user.lesson_settings && user.lesson_settings.preffered_lesson_duration == "30") ? '(Preferred duration)' : ''}}</option>
            <option value="45">45 minutes {{(user && user.lesson_settings && user.lesson_settings && user.lesson_settings.preffered_lesson_duration == "45") ? '(Preferred duration)' : ''}}</option>
            <option value="60">60 minutes {{(user && user.lesson_settings && user.lesson_settings && user.lesson_settings.preffered_lesson_duration == "60") ? '(Preferred duration)' : ''}}</option>
            <option value="90">90 minutes {{(user && user.lesson_settings && user.lesson_settings && user.lesson_settings.preffered_lesson_duration == "90") ? '(Preferred duration)' : ''}}</option>
            <option value="120">120 minutes {{(user && user.lesson_settings && user.lesson_settings && user.lesson_settings.preffered_lesson_duration == "120") ? '(Preferred duration)' : ''}}</option>
          </select>
          <img class="arrow" src="~@/assets/arrow-right-white-2.svg" />
        </div> -->

                <has-error class="info error" :form="form" field="duration" />

                <div class="select" v-if="user.type == 'pro' && clubs.length > 1">
                    <select
                        class="button dark"
                        v-model="form.venue"
                        :class="{ complete: form.venue }"
                    >
                        <option value="">Select venue</option>
                        <option :value="club.id" v-for="club in clubs" :key="club.id">
                            {{ club.name }}
                        </option>
                    </select>
                    <img class="arrow" src="~@/assets/arrow-right-white-2.svg" />
                </div>

                <lesson-pro-date-picker
                    class="datePicker"
                    ref="datePicker"
                    style="width: 100%; margin-bottom: 10px"
                    type="player"
                    v-model="form.date"
                    @timesAdded="addTimes"
                    @calendarOpen="form.time = []"
                    :duration="form.duration"
                />

                <has-error class="info error" :form="form" field="date" />

                <lesson-pro-time-picker
                    v-model="form.time"
                    :times="times"
                    :timePickerOpen="timePickerOpen"
                    @timePickerClosed="
                        timeChosen = true;
                        timePickerOpen = false;
                    "
                    @timePickerOpen="timePickerOpen = true"
                />

                <has-error class="info error" :form="form" field="time" />

                <button
                    type="button"
                    name="button"
                    class="button dark left"
                    @click.prevent="noteOpen = true"
                    v-if="!noteOpen"
                >
                    Add a note to this lesson
                    <img class="arrow" src="~@/assets/arrow-right-white-2.svg" />
                </button>

                <div class="formGroup" v-else>
                    <textarea
                        :class="{ selected: form.note }"
                        name="name"
                        v-model="form.note"
                        placeholder="Add a note to this lesson (optional)"
                    ></textarea>
                </div>

                <!-- <div class="formGroup" v-if="form.duration && form.date && timeChosen && form.player_id !== 'guest'" style="margin-bottom:20px;">
          <label class="radio half" :class="{active:form.payment_type == 'credits'}">
            <input type="radio" v-model="form.payment_type" value="credits" />
            Use credits
          </label>

          <label class="radio half" :class="{active:form.payment_type == 'on_day'}">
            <input type="radio" v-model="form.payment_type" value="on_day" />
            Pay on day
          </label>
        </div> -->

                <has-error class="info error" :form="form" field="credits" />

                <has-error class="info error" :form="form" field="payment_type" />

                <button
                    :disabled="form.busy"
                    class="button half"
                    style="margin-right: 10px"
                    v-if="form.duration && form.date && timeChosen"
                    type="submit"
                    name="button"
                >
                    {{ form.busy ? "Please wait..." : "Update" }}
                </button>

                <button
                    @click.prevent="cancelLesson"
                    class="button red"
                    :class="{ half: form.duration && form.date && timeChosen }"
                >
                    Cancel Lesson
                </button>

                <p style="margin-top: 10px" v-if="form.duration && form.date && timeChosen">
                    Once a booking has been placed a cancellation will only be accepted with a
                    minumum of 24 hours notice before the lesson is due to commence. Full payment
                    will be due for lessons cancelled after this period
                </p>
            </form>
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import LessonProDatePicker from "@/components/App/lesson-pro-date-picker";
import LessonProTimePicker from "@/components/App/lesson-pro-time-picker";
import { XIcon } from "vue-feather-icons";
import { Form, HasError } from "vform";
export default {
    name: "book",
    components: {
        FadeImage,
        XIcon,
        HasError,
        LessonProDatePicker,
        LessonProTimePicker,
    },
    computed: {
        players() {
            return this.$store.state.players;
        },
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        if (this.user.type == "pro" && this.players.length == 0) {
            this.$store.dispatch("getPlayers");
        }

        this.getClubs();

        if (this.$route.query.id) {
            this.form.player_id = this.$route.query.id;
        }

        this.getBooking();
    },
    data() {
        return {
            times: [],
            timeChosen: false,
            timePickerOpen: false,
            noteOpen: false,
            clubs: [],
            form: new Form({
                player_id: "",
                duration: "",
                date: "",
                time: [],
                note: "",
                payment_type: "",
                credits: false,
                guest_name: "",
                venue: false,
            }),
        };
    },
    methods: {
        cancelLesson() {
            var msg = "";

            var TwnetyFourHrs = this.$date().add(24, "hour");

            console.log(this.$date(this.lesson.date).isBetween(this.$date(), TwnetyFourHrs));
            if (
                this.lesson.payment_type == "credits" &&
                this.$date(this.lesson.date).isBetween(this.$date(), TwnetyFourHrs)
            ) {
                var credits = this.lesson.duration / 15;
                msg =
                    '<br><br><span style="color:#bd6262">There is less than 24 hours before your lesson starts. If you proceed the ' +
                    credits +
                    " credits used to make this booking will not be refunded.</span>";
            }

            this.$confirm(
                "Are you sure you want to cancel this lesson?" + msg,
                () => {
                    this.form.delete("/lesson/" + this.$route.params.id).then(() => {
                        if (this.user.type == "pro") {
                            this.$router.push({ name: "proLesson" });
                            this.$notify(
                                "This lesson has been cancelled. A notification has been sent to the player",
                            );
                        } else {
                            this.$notify("This lesson has been cancelled.");
                            this.$router.push({ name: "playerLessons" });
                        }
                    });
                },
                "Yes",
                "No",
            );
        },
        getClubs() {
            this.form.get("/club").then((response) => {
                this.clubs = response.data;
            });
        },
        getBooking() {
            this.form.get("/lesson/" + this.$route.params.id).then((response) => {
                this.lesson = response.data;

                if (response.data.guest_name) {
                    this.form.guest_name = response.data.guest_name;
                    this.form.player_id = "guest";
                } else {
                    this.form.player_id = response.data.player.id;
                }

                this.form.duration = String(response.data.duration);
                this.form.date = response.data.date;
                this.form.note = response.data.note;
                this.form.payment_type = response.data.payment_type;
                this.form.venue = response.data.venue;

                this.form.time.push({
                    start: response.data.start,
                    end: response.data.end,
                });
                this.timeChosen = true;
                this.getAvailability(response.data);

                if (this.form.note) {
                    this.noteOpen = true;
                }
            });
        },
        resetForm() {
            this.timePickerOpen = false;
            this.timeChosen = false;
            this.form.time = [];
            this.form.date = "";
            this.$refs.datePicker.resetCalendar();
        },
        addTimes(times) {
            // Recieved the dates from the chosen dates from lesson-pro-date-picker
            this.times = times;
        },
        getAvailability($lesson) {
            var date = this.$date($lesson.date);

            window.axios
                .get(
                    "/booking/availability?month=" +
                        date.format("M") +
                        "&year=" +
                        date.format("YYYY") +
                        "&duration=" +
                        $lesson.duration,
                )
                .then((response) => {
                    var filtered = response.data.filter((date) => {
                        return this.$date(date.date).isSame(this.$date($lesson.date), "day");
                    });

                    this.times = filtered;
                });
        },
        updateBooking() {
            this.form.post("/booking/" + this.$route.params.id).then((response) => {
                this.$notify({
                    text: "Lesson updated",
                });

                if (this.user.type == "pro") {
                    this.$store.dispatch("updateProLesson", response.data.lessons[0]);
                    this.$router.push({ name: "proLesson" });
                } else {
                    this.$store.dispatch("updateLesson", response.data.lessons[0]);
                    this.$store.dispatch("updateNextLesson", response.data.next_lesson);
                    this.$router.push({ name: "playerLessons" });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#playerBook {
    .button {
        margin-bottom: 10px;
        &.complete {
            background: white;
            color: $green_0;
        }
        .arrow {
            position: absolute;
            right: 20px;
            top: 20px;
        }
    }

    p {
        line-height: 1.5;
        color: $green_0;
    }
    .select {
        .arrow {
            position: absolute;
            right: 20px;
            top: 20px;
        }
        .button {
            padding-left: 17px !important;
        }
    }
    p {
        font-weight: 200;
        font-size: 14px;
    }
    #guestName {
        margin-bottom: 10px;
        input[type="text"].complete {
            background: white;
        }
    }
}
</style>
